(function () {
  'use strict';

  var stickyBar = document.getElementById('sticky-atc');
  if (!stickyBar) return;

  /* ── Real controls on the main product page (single source of truth) ── */
  var mainAddCartBtn   = document.getElementById('add-cart-btn');
  var mainQtyDec       = document.getElementById('qty-dec');
  var mainQtyInc       = document.getElementById('qty-inc');
  var mainQtyVal       = document.getElementById('qty-val');
  var mainWeightSelect = document.querySelector('.weight-select');
  var mainPriceCurrent = document.querySelector('.info-panel .price-current');
  var mainPriceOrig    = document.querySelector('.info-panel .price-original');
  var mainAddRow       = document.querySelector('.add-row');

  /* ── Sticky bar's own controls ── */
  var stickyQtyDec        = document.getElementById('sticky-qty-dec');
  var stickyQtyInc        = document.getElementById('sticky-qty-inc');
  var stickyQtyVal        = document.getElementById('sticky-qty-val');
  var stickyWeightSelect  = document.getElementById('sticky-weight-select');
  var stickyPriceCurrent  = document.getElementById('sticky-price-current');
  var stickyPriceOrig     = document.getElementById('sticky-price-original');
  var stickyAddCartBtn    = document.getElementById('sticky-add-cart-btn');
  var stickyBuyNowBtn     = document.getElementById('sticky-buynow-btn');

  /* ── Quantity: puppet the real +/- buttons, mirror #qty-val back ──
     product.js owns the qty variable; we never track our own copy. */
  if (stickyQtyDec && mainQtyDec) {
    stickyQtyDec.addEventListener('click', function () { mainQtyDec.click(); });
  }
  if (stickyQtyInc && mainQtyInc) {
    stickyQtyInc.addEventListener('click', function () { mainQtyInc.click(); });
  }

  if (mainQtyVal && stickyQtyVal) {
    stickyQtyVal.textContent = mainQtyVal.textContent;
    new MutationObserver(function () {
      stickyQtyVal.textContent = mainQtyVal.textContent;
    }).observe(mainQtyVal, { childList: true, characterData: true, subtree: true });
  }

  /* ── Variant: puppet the real weight select so product.js's own
     updateVariantUI() runs (price, SKU, gallery, url, add-cart variant id).
     Mirror the main select back when it changes from the main page itself. */
  if (stickyWeightSelect && mainWeightSelect) {
    stickyWeightSelect.value = mainWeightSelect.value;

    stickyWeightSelect.addEventListener('change', function () {
      mainWeightSelect.value = stickyWeightSelect.value;
      mainWeightSelect.dispatchEvent(new Event('change', { bubbles: true }));
    });

    mainWeightSelect.addEventListener('change', function () {
      stickyWeightSelect.value = mainWeightSelect.value;
    });
  }

  /* ── Price: mirror the real price display's text/visibility, no
     independent price lookup or formatting logic. */
  function mirrorPrice() {
    if (stickyPriceCurrent && mainPriceCurrent) {
      stickyPriceCurrent.textContent = mainPriceCurrent.textContent;
    }
    if (stickyPriceOrig && mainPriceOrig) {
      stickyPriceOrig.textContent = mainPriceOrig.textContent;
      stickyPriceOrig.style.display = mainPriceOrig.style.display === 'none' ? 'none' : '';
    }
  }

  mirrorPrice();
  if (mainPriceCurrent && mainPriceCurrent.parentNode) {
    new MutationObserver(mirrorPrice).observe(mainPriceCurrent.parentNode, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style']
    });
  }

  /* ── Sold-out state: mirror the main Add to Cart / Buy Now buttons'
     disabled/text/visibility, no independent availability logic. ── */
  var mainBuyNowBtn = document.getElementById('buynow-btn');

  function mirrorSoldOutState() {
    if (stickyAddCartBtn && mainAddCartBtn) {
      stickyAddCartBtn.disabled = mainAddCartBtn.disabled;
      stickyAddCartBtn.textContent = mainAddCartBtn.textContent;
    }
    if (stickyBuyNowBtn && mainBuyNowBtn) {
      stickyBuyNowBtn.disabled = mainBuyNowBtn.disabled;
      stickyBuyNowBtn.style.display = mainBuyNowBtn.style.display;
    }
  }

  mirrorSoldOutState();
  if (mainAddCartBtn) {
    new MutationObserver(mirrorSoldOutState).observe(mainAddCartBtn, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled']
    });
  }
  if (mainBuyNowBtn) {
    new MutationObserver(mirrorSoldOutState).observe(mainBuyNowBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'style']
    });
  }

  /* ── Add to Cart / Buy Now: both delegate to the single shared
     window.tovAddToCart (defined in tov-header.js) - no parallel cart logic. */
  function currentQty() {
    return parseInt((mainQtyVal && mainQtyVal.textContent) || '1', 10) || 1;
  }

  function currentVariantId() {
    return mainAddCartBtn ? mainAddCartBtn.dataset.variantId : null;
  }

  if (stickyAddCartBtn) {
    stickyAddCartBtn.addEventListener('click', function () {
      var variantId = currentVariantId();
      if (!variantId || typeof window.tovAddToCart !== 'function') return;
      window.tovAddToCart(variantId, currentQty(), stickyAddCartBtn);
    });
  }

  if (stickyBuyNowBtn) {
    stickyBuyNowBtn.addEventListener('click', function () {
      var variantId = currentVariantId();
      if (!variantId || typeof window.tovAddToCart !== 'function') return;
      window.tovAddToCart(variantId, currentQty(), stickyBuyNowBtn, { openDrawer: false })
        .then(function () {
          window.location.href = ((window.Theme && Theme.routes.root_url) || '/') + 'checkout';
        })
        .catch(function () {});
    });
  }

  /* ── Visibility: hidden until the real Add to Cart button/section has
     scrolled past (out of view above the viewport); hides again once it's
     back in view (scrolling back up). ── */
  var watchTarget = mainAddRow || mainAddCartBtn;
  if (watchTarget && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('visible');
          return;
        }
        // Only show once scrolled past (target above viewport), not before
        // it's been reached (target below viewport).
        if (entry.boundingClientRect.bottom < 0) {
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(watchTarget);
  }
})();
